import { Controller } from "@hotwired/stimulus"

let shouldRestoreFocus = false
let shouldShowFlash = false

export default class extends Controller {
  static targets = ["input"]
  static values = {
    step: { type: Number, default: 1 },
    max: { type: Number, default: 999 },
    delay: { type: Number, default: 300 }
  }

  connect() {
    if (shouldRestoreFocus) {
      this.inputTarget.focus()
      shouldRestoreFocus = false
    }

    if (shouldShowFlash) {
      shouldShowFlash = false
      this.flashSuccess()
    }

    this.form = this.element.closest("form")
    this.handleSubmitEnd = this.onSubmitEnd.bind(this)
    this.form?.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  decrement() {
    const current = parseInt(this.inputTarget.value) || this.stepValue
    const newVal = current - this.stepValue

    if (newVal < this.stepValue) {
      this.inputTarget.value = 0
    } else {
      this.inputTarget.value = newVal
    }

    this.scheduleSubmit()
  }

  increment() {
    const current = parseInt(this.inputTarget.value) || 0
    const newVal = current + this.stepValue

    if (this.maxValue > 0 && newVal > this.maxValue) return

    this.inputTarget.value = newVal
    this.scheduleSubmit()
  }

  change() {
    let val = parseInt(this.inputTarget.value) || this.stepValue

    if (this.stepValue > 1) {
      val = Math.ceil(val / this.stepValue) * this.stepValue
    }

    if (this.maxValue > 0 && val > this.maxValue) val = this.maxValue
    if (val < 0) val = 0
    if (val > 0 && val < this.stepValue) val = this.stepValue

    this.inputTarget.value = val
    this.scheduleSubmit()
  }

  scheduleSubmit() {
    if (this.submitTimeout) clearTimeout(this.submitTimeout)

    shouldRestoreFocus = document.activeElement === this.inputTarget
    shouldShowFlash = true

    this.submitTimeout = setTimeout(() => {
      this.startLoading()
      this.form?.requestSubmit()
    }, this.delayValue)
  }

  startLoading() {
    this.element.classList.add("opacity-60", "pointer-events-none")
  }

  stopLoading() {
    this.element.classList.remove("opacity-60", "pointer-events-none")
  }

  flashSuccess() {
    this.element.classList.add("ring-2", "ring-green-400")
    setTimeout(() => {
      this.element.classList.remove("ring-2", "ring-green-400")
    }, 600)
  }

  onSubmitEnd(event) {
    this.stopLoading()
    shouldShowFlash = false

    if (event.detail?.success) {
      this.flashSuccess()
    }
  }

  disconnect() {
    if (this.submitTimeout) clearTimeout(this.submitTimeout)
    this.form?.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }
}
